import { get, post } from './http'

export default {
  getAddressList(openid, aid='') {
    return get('User/getUserAddress', {
      openid: openid,
      aid: aid
    });
  },
  updateAddress(openid, addressModel) {
    return post(`User/setUserAddress?openid=${openid}`, addressModel);
  }
}



// WEBPACK FOOTER //
// ./src/request/addressApi.js